import { Sprite } from 'pixi.js';
import { FrameConfig } from '@/types/uiTypes';

class Button extends Sprite {
	isButton = true;
	hover: boolean;
	handler: FrameConfig['handler'] | null = null;

	constructor(obj: FrameConfig) {
		super();

		this.interactive = true;
		this.hover = true;
		this.handler = obj.handler || null;
		this.name = obj.name;

		this.cursor = obj.cursor || 'pointer';

		if (obj.hover !== undefined) {
			this.hover = obj.hover;
		}

		const isTouchedDevice = window.isMobile || window.isTablet;
		this.on(isTouchedDevice ? 'tap' : 'click', this.clickHandler.bind(this));
		this.on(
			isTouchedDevice ? 'touchendoutside' : 'mouseupoutside',
			this.mouseUpOutsideHandler.bind(this)
		);

		if (!isTouchedDevice) {
			this.on('mouseover', this.mouseOverHandler.bind(this));
		}
	}

	clickHandler() {
		if (this.handler) {
			this.handler(this.name);
		}
	}

	mouseOverHandler() {}
	mouseDownHandler() {}
	mouseUpHandler() {}
	mouseUpOutsideHandler() {}
}

export default Button;
